import { render, staticRenderFns } from "./MktAgreePopup.vue?vue&type=template&id=5eb22b43&scoped=true&"
import script from "./MktAgreePopup.vue?vue&type=script&lang=js&"
export * from "./MktAgreePopup.vue?vue&type=script&lang=js&"
import style0 from "./MktAgreePopup.vue?vue&type=style&index=0&id=5eb22b43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb22b43",
  null
  
)

export default component.exports